import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './redux/store';

import NotFound from './pages/NotFound';
import BlankPage from './shared/components/BlankPage';

import LayoutMain from './shared/layouts/LayoutMain';
import LayoutSub from './shared/layouts/LayoutSub';
import routersSub from './routers/RoutersSub';
import routersMain from './routers/RoutersMain';
import routerOther from './routers/RoutersOther';
import ForbiddenError from './pages/ForbiddenError';
import { useKakaoLoader } from 'react-kakao-maps-sdk';
import { APPKEY } from './shared/constants/app';

import ScrollToTop from './shared/components/ScrollToTop';
import GoogleAnalytics from './shared/components/GoogleAnalytics';

function App() {
    useKakaoLoader({
        appkey: APPKEY,
        libraries: ['services'],
    });

    return (
        <Provider store={store}>
            <PersistGate persistor={persistor}>
                <BrowserRouter>
                    <ScrollToTop />
                    <GoogleAnalytics />
                    <Routes>
                        {routerOther.map((item, index) => (
                            <Route key={index} path={item.path} element={<item.element />} />
                        ))}
                        <Route element={<LayoutMain />}>
                            {routersMain.map((item, index) => (
                                <Route key={index} path={item.path} element={<item.element />} />
                            ))}
                            <Route path="/blank-page" element={<BlankPage />} />
                        </Route>
                        <Route element={<LayoutSub />}>
                            {routersSub.map((item, index) => (
                                <Route key={index} path={item.path} element={<item.element />} />
                            ))}
                        </Route>
                        <Route path="/forbidden" element={<ForbiddenError />} />
                        <Route path="/notfound" element={<NotFound />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    );
}

export default App;
